'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dateFns = require('date-fns');

exports.default = function (value) {
  var date = value.endsWith('m') ? value.slice(0, -1) : value;
  var isPm = date.endsWith('p');
  var properDate = date.endsWith('a') || date.endsWith('p') ? date.slice(0, -1) : date;
  return isPm ? (0, _dateFns.addHours)(properDate, 12) : properDate;
};